import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const newspaperApproval = async (data: any) => {
	const URL = `${API_URL}GetNewspaperAllowancesByOrganisationID`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		newspaperApprovalToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const approveNewspaper = async (data: any) => {
	const URL = `${API_URL}ApproveNewspaperAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		approveNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const rejectNewspaper = async (data: any) => {
	const URL = `${API_URL}RejectNewspaperAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		rejectNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const bulkApproveNewspaper = async (data: any) => {
	const URL = `${API_URL}BulkApproveNewspaperAllowances`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		bulkApproveNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const deleteNewspaper = async (data: any) => {
	const URL = `${API_URL}DeleteNewspaperAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		deleteNewspapertoken: data,
	};
	return makeApiCall(URL, requestData);
};
